import { useEffect, useState } from "preact/hooks";
import { Gold } from "./Gold";

/** The board's and the Schedules screen's toast. Overlays the list without moving cards; reserve the last 180ms for the exit. With no gold, the plain `text` alone ("Task added"). */
export function AwardToast({ gold, text = "Work complete.", onDismiss }: { gold: number | null; text?: string; onDismiss: () => void }) {
  const [leaving, setLeaving] = useState(false);
  useEffect(() => {
    const exit = window.setTimeout(() => setLeaving(true), 2320);
    const t = window.setTimeout(onDismiss, 2500);
    return () => { window.clearTimeout(exit); window.clearTimeout(t); };
  }, [onDismiss]);
  return (
    <div class={`award-toast${leaving ? " award-toast-leaving" : ""}`} role="status" aria-atomic="true">
      {gold !== null && (
        <>
          <Gold amount={gold} prefix="+" />{" "}
        </>
      )}
      <span>{text}</span>
    </div>
  );
}
